// extracted by mini-css-extract-plugin
export default {"page":"Page_page__6h+8u","content":"Page_content__Cg79g","children":"Page_children__gyN7+","disclaimer":"Page_disclaimer__WGNap"};